import firebase from '@/firebase/firebase'

export function elapsedTime(startTime) {
  let x        = new Date(startTime)
  let now      = new Date()
  var timeDiff = now - x
  timeDiff    /= 1000

  var seconds = Math.round(timeDiff)
  timeDiff    = Math.floor(timeDiff / 60)

  var minutes = Math.round(timeDiff % 60)
  timeDiff    = Math.floor(timeDiff / 60)

  var hours   = Math.round(timeDiff % 24)
  timeDiff    = Math.floor(timeDiff / 24)

  var days    = Math.round(timeDiff % 365)
  timeDiff    = Math.floor(timeDiff / 365)

  var years   = timeDiff

  if (years > 0) {
    return years + (years > 1 ? ' Anos ' : ' Ano ') + 'atrás'
  } else if (days > 0) {
    return days + (days > 1 ? ' Dias ' : ' Dia ') + 'atrás'
  } else if (hours > 0) {
    return hours + (hours > 1 ? ' Horas ' : ' Hora ') + 'atrás'
  } else if (minutes > 0) {
    return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'atrás'
  } else if (seconds > 0) {
    return  (seconds > 1 ? seconds + ' segs atrás' : 'agora')
  }

  return 'Agora'
}

export function truncateText (str, truncateTo) {
  return `${str.substr(0, truncateTo)}${str.length > truncateTo ? '...' : ''}`
}
export default {
  removeSpecialChars(str) {
    str = str.toUpperCase()
    str = str.replace(/[ÀÁÂÃÄÅ]/g,"A");
    str = str.replace(/[ÈÉÊË]/g,"E");
    str = str.replace(/[ÙÚÛÜ]/g,"U");
    str = str.replace(/[ÌÍÏÎ]/g,"I");
    str = str.replace(/[ÒÓÕÔÖ]/g,"O");
    str = str.replace(/[Ç]/g,"C");
    return str.trim().replace(/[^a-zA-Z0-9 ]/g, "");
  },

  diferenceBetweenDates (date1, date2) {
    var delta = Math.abs(date1 - date2) / 1000;
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    var seconds = delta % 60;

    return { days, hours, minutes, seconds }
  },

  convertToFBTimeStamp (sec, nano) {
      if(sec && nano)
          return new firebase.firestore.Timestamp(sec, nano).toDate()

      return 'Horário desconhecido'
  },

  truncateDecimals (number, by = 100) {
    number = number * by
    return Math[number < 0 ? 'ceil' : 'floor'](number) / by;
  },

  generateId (length, justUpperCase = false) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    if(justUpperCase) characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },

  getCurrentDate () {
    let date = new Date();
    return date
  },

  reduceName(name) {
    let newName = (name + '').trim().split(' ')
    if (newName.length > 3) newName = (`${newName[0]} ${newName[1]} ${newName[2][0]}.`).slice(0, 19); else newName = (newName.join(' ') || 'Sem nome').slice(0, 19)
    return newName
  },

  formatDate (date) {
    var d     = new Date(date)
    var month = '' + d.getMonth()
    var day   = '' + d.getDate()
    var year  = d.getFullYear()

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
  },

  formatDateTime (date) {
    var d = new Date(date)
    var month = '' + d.getMonth()
    var day   = '' + d.getDate()
    var year  = d.getFullYear()
    var hours = String(d.getHours()).padStart(2, '0')
    var mins  = String(d.getMinutes()).padStart(2, '0')
    var secs  = String(d.getSeconds()).padStart(2, '0')

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/') + ' ' + [hours, mins, secs].join(':');
  },

  formatPrice (price) {
    if(!price) return '0,00'
    return price.toFixed(2).replace('.',',')
  },

  validateCPF (cpf) {
    if(typeof(cpf) == 'undefined') return false;	
    cpf = cpf.replace(/[^\d]+/g,'');	
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 || 
      cpf == "00000000000" || 
      cpf == "11111111111" || 
      cpf == "22222222222" || 
      cpf == "33333333333" || 
      cpf == "44444444444" || 
      cpf == "55555555555" || 
      cpf == "66666666666" || 
      cpf == "77777777777" || 
      cpf == "88888888888" || 
      cpf == "99999999999")
        return false;		
    // Valida 1o digito	
    var add = 0;	
    for (var i=0; i < 9; i ++)		
      add += parseInt(cpf.charAt(i)) * (10 - i);	
      var rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11)		
        rev = 0;	
      if (rev != parseInt(cpf.charAt(9)))		
        return false;		
    // Valida 2o digito	
    add = 0;	
    for (i = 0; i < 10; i ++)		
      add += parseInt(cpf.charAt(i)) * (11 - i);	
    rev = 11 - (add % 11);	
    if (rev == 10 || rev == 11)	
      rev = 0;	
    if (rev != parseInt(cpf.charAt(10)))
      return false;		
    return true; 
  },

  validateCNPJ (cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g,'');
 
    if(cnpj == '') return false;
     
    if (cnpj.length != 14)
        return false;
 
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" || 
        cnpj == "11111111111111" || 
        cnpj == "22222222222222" || 
        cnpj == "33333333333333" || 
        cnpj == "44444444444444" || 
        cnpj == "55555555555555" || 
        cnpj == "66666666666666" || 
        cnpj == "77777777777777" || 
        cnpj == "88888888888888" || 
        cnpj == "99999999999999")
        return false;
         
    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
         
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;
           
    return true;
  },


}

export function truncateNumber (value) {
  return Math.round(value * 100 + Number.EPSILON) / 100;
}